<template>
  <div class="about">
    <v-toolbar flat>
      <v-toolbar-title><v-icon color="blue">mdi-format-list-bulleted</v-icon></v-toolbar-title>
      <base-breadcrumbs :items="breadcrumbs" />
    </v-toolbar>
    <balai :dinas-id="dinasId" />
  </div>
</template>
<script>
import BaseBreadcrumbs from '@components/base/BaseBreadcrumbs';
import Balai from './components/Balai';
import { mapActions } from 'vuex';

export default {
  name: 'LaporanIhtBalai',
  components: { BaseBreadcrumbs, Balai },
  data() {
    return {
      instansiBalai: {},
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { text: 'Daftar Balai', to: 'iht-balai' },
        { text: `Laporan IHT ${this.$getDeepObj(this.instansiBalai, `${this.dinasId}.nama`)}` },
      ];
    },

    dinasId() {
      return this.$route.params.dinas_id || null;
    },
  },
  created() {
    this.fetchInstansiBalai();
  },
  methods: {
    ...mapActions('preferensi', ['getInstansiBalai']),

    async fetchInstansiBalai() {
      const instansiBalai = await this.getInstansiBalai();
      this.instansiBalai = this.$arrToObj(instansiBalai, 'instansi_id');
    },
  },
};
</script>
